import React from 'react';
import './LegalPage.css';

export default function Terms() {
  return (
    <div className="legal-page">
      <div className="legal-shell">
        <section className="legal-hero">
          <span className="legal-kicker">Terms</span>
          <h1>Terms of Service</h1>
          <p>
            These terms outline how Anora Store operates, what customers can expect from orders placed through the site,
            and the basic rules that apply when using our storefront.
          </p>
          <div className="legal-updated">Last updated: March 31, 2026</div>
        </section>

        <div className="legal-content">
          <section className="legal-card">
            <h2>Store use</h2>
            <p>
              By using Anora Store, you agree to provide accurate checkout and support information and to use the site only for lawful purchases and account-related requests.
            </p>
          </section>

          <section className="legal-card">
            <h2>Orders and availability</h2>
            <ul>
              <li>Listings may change as inventory updates or synced marketplace items sell elsewhere.</li>
              <li>Orders are subject to availability and may be canceled if an item is no longer in stock.</li>
              <li>Prices, shipping methods, and delivery estimates are shown as accurately as possible at checkout.</li>
            </ul>
          </section>

          <section className="legal-card">
            <h2>Payments and shipping</h2>
            <ul>
              <li>Payments are processed through third-party providers such as Stripe and PayPal.</li>
              <li>Shipping rates and timelines depend on the destination, carrier availability, and the information supplied during checkout.</li>
              <li>International shipping may be limited by carrier rules, customs restrictions, or destination support.</li>
            </ul>
          </section>

          <section className="legal-card">
            <h2>Returns and support</h2>
            <p>
              If there is a problem with your order, contact us through the <a href="/support">Support Center</a> or by phone at <a href="tel:5612851789">561-285-1789</a>.
              Eligible orders are covered by a 30-day free return policy, and we review damaged-item and order-issue requests case by case to guide you on the next best resolution.
            </p>
          </section>

          <section className="legal-card">
            <h2>Content and limitations</h2>
            <p>
              Product descriptions, synced marketplace details, and images are presented in good faith, but occasional listing errors or delays can happen.
              Anora Store may update the site, these terms, or storefront content at any time as the business evolves.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
